import React from 'react';
import { RESULT_TYPES } from '../constants/config';
import ResultPage from '../components/ResultPage';
import useScrollToTop from '../hooks/useScrollToTop';

const NotFound = () => {
  useScrollToTop();

  return (
    <ResultPage
      type={RESULT_TYPES.notFound}
      title="Page Not Found"
      message="Oops! Looks like you took a wrong turn. This page doesn't exist. But don't worry, our tour guides never get lost. Let's get you back on track!"
    />
  );
};

export default NotFound;
